import { OnlineAnalysisFilterValues } from '../../../Filter/Types';
import { SkinAnalysisSectionIdentifier } from '../../../Types';
import { BirthDay, DataProcessingScope } from '../../../Api/Types';
import { IngredientId } from '../../../Api/Inci/Types';
import { CustomerId } from '../../../Api/Account/Types';

export interface Account {
    id: CustomerId;
    skinAnalyses: AccountSkinAnalysis[];
    onlineAnalyses: AccountOnlineAnalysis[];
    creationDateTime: Date;
    lastModificationDateTime: Date;
    salutation: string;
    greeting: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    phoneNumber2: string;
    city: string;
    postCode: string;
    street: string;
    country: string;
    birthDate: BirthDay | null;
    companyName: string | null;
    vatin: string | null;
    privacyAccepted: boolean;
    privacyAcceptedDate: string;
    profiles: Profile[];
    excludedIngredients: IngredientId[];
    dataProcessingConsents: DataProcessingScope[];
}

export interface AccountPostData extends Omit<Account, 'birthDate'> {
    birthDate: string | null;
}

export interface CompanyAccount extends Account {
    birthDate: null;
    companyName: string;
}

export interface Profile {
    id: CustomerId;
    profileName: string;
    skinAnalyses: AccountSkinAnalysis[];
    excludedIngredients: IngredientId[];
}

export interface AccountOrProfile {
    id: CustomerId;
    displayName: string;
    excludedIngredients: IngredientId[];
    skinAnalyses: AccountSkinAnalysis[];
}

export interface AccountSkinAnalysis {
    id: string;
    label: string;
    answeredSections: SkinAnalysisSectionIdentifier[];
    default: boolean;
    byPhone: boolean;
    nextGenMeetingId: string | null;
    consultant: {
        salutation: 'mr' | 'ms';
        firstName: string;
        lastName: string;
        image: string | null;
        qualification: number | null;
    };
    creationDateTime: Date;
    type: 'consultant' | 'meeting';
}

export interface AccountOnlineAnalysis {
    id: string;
    answers: OnlineAnalysisFilterValues;
    creationDateTime: Date;
}

export enum SaveState {
    InProgress,
    Successful,
    Failure,
}
